import EditConfigurationForm  from '../components/Forms/EditConfigurationForm';
import { useLocation } from "react-router-dom";

function EditConfigurationPage() {
    const location = useLocation();
    const productName = location.state.productName || "";
    const configurationName = location.state.configurationName || "";
    
    return <section style={{margin: "20px"}}>
        <h1>Edit Configuration</h1>

        <EditConfigurationForm
            productName={productName}
            configurationName={configurationName}
        />
    </section>
}

export default EditConfigurationPage;